import { TFunction } from 'i18next';

export const formatTargetPerformance = (
  t: TFunction,
  targetValue: number | undefined,
  duration: number | undefined,
) => {
  const targetPerformance = targetValue && duration ? (targetValue - duration) / 1000 / 60 : 0;
  return formatTargetPerformanceDirect(t, targetPerformance);
};

export const formatTargetPerformanceDirect = (t: TFunction, targetPerformance: number) => {
  let targetPerformanceValue;
  if (targetPerformance) {
    // We split the time here in minutes and seconds.
    const minutes = Math.floor(targetPerformance);
    const seconds = Math.floor((targetPerformance % 1) * 60);
    if (targetPerformance > 0) {
      targetPerformanceValue =
        seconds > 0
          ? t(['shared:nInMinutesAndSecAhead'], {
              defaultValue: '{{minutes}}min {{seconds}}sec ahead',
              minutes,
              seconds,
            })
          : t(['shared:nInMinutesAhead'], {
              defaultValue: '{{minutes}}min ahead',
              minutes,
            });
    } else if (targetPerformance < 0) {
      targetPerformanceValue =
        seconds > 0
          ? t(['shared:nInMinutesAndSecBehind'], {
              defaultValue: '{{minutes}}min {{seconds}}sec behind',
              minutes,
              seconds,
            })
          : t(['shared:nInMinutesBehind'], {
              defaultValue: '{{minutes}}min behind',
              minutes,
            });
    } else {
      targetPerformanceValue = t(['device:exactlyOnTarget'], {
        defaultValue: 'Exactly on target',
      });
    }
  }
  return targetPerformanceValue;
};
